export enum TagDeferralLabel {
	Rejected = 'Indeferido',
	Deferred = 'Deferido',
	Pending = 'Pendente'
}
